import TcListPage from 'components/UI/TcListPage/TcListPage';
import TcPageTitle from 'components/UI/pageTitle/TcPageTitle';
import BranchCustomerProductExcel from 'components/pages/dashboard/branchCustomerProductType/components/BranchCustomerProductExcel';
import endpointUrls from 'global/Constants/endpointUrls';
import branchCustomerProductTypeModel, { branchCustomerProduct } from 'global/Models/branchCustomerProductTypeModel';
import { IBackendSearchGeneric } from 'global/Models/globalModels';
import { handleApiThenGeneric } from 'global/helperFunctions/handleApiThen';
import ApiService from 'global/utils/ApiService';
import { FC, useState } from 'react';
interface props {}
const BranchCustomerProductMyRequests: FC<props> = () => {
  //states
  const [list, setList] = useState<IBackendSearchGeneric<branchCustomerProduct>>();
  const [loading, setLoading] = useState<boolean>(false);

  const getList = async (query: Record<string, any>) => {
    setLoading(true);
    await ApiService.post(endpointUrls.branchCustomerProductGetAll, { ...query })
      .then((res: IBackendSearchGeneric<branchCustomerProduct>) =>
        handleApiThenGeneric<IBackendSearchGeneric<branchCustomerProduct>, branchCustomerProduct[]>({
          res,
          onSuccess: setList,
          notifFail: false,
          notifSuccess: false,
          onFailed: () => setList(undefined),
        })
      )
      .catch(() => setList(undefined));
    setLoading(false);
  };

  const renderExcel = <BranchCustomerProductExcel />;
  return (
    <>
      <TcPageTitle title='درخواست های من' />
      <TcListPage
        columns={branchCustomerProductTypeModel.columnsMyReq()}
        list={list}
        getList={getList}
        loading={loading}
        filterItems={branchCustomerProductTypeModel.filterItemsMyTab}
        additionalContent={renderExcel}
      />
    </>
  );
};
export default BranchCustomerProductMyRequests;
